// Generated by CoffeeScript 1.10.0
(function() {
  var dereference, inherit, ref1, uniqueMembers;

  ref1 = require('./inherit'), uniqueMembers = ref1.uniqueMembers, inherit = ref1.inherit;

  module.exports = dereference = function(root, dataStructures) {
    var base, i, item, j, len, member, properties, property, ref, ref2;
    switch (root.element) {
      case 'enum':
      case 'array':
        root.content = (function() {
          var j, len, ref2, results;
          ref2 = root.content || [];
          results = [];
          for (j = 0, len = ref2.length; j < len; j++) {
            item = ref2[j];
            results.push(dereference(item, dataStructures));
          }
          return results;
        })();
        return root;
      case 'object':
        properties = root.content ? root.content.slice(0) : [];
        i = 0;
        while (i < properties.length) {
          member = properties[i];
          i++;
          if (member.element === 'ref') {
            i--;
            ref = dataStructures[member.content.href];
            ref.content = JSON.parse(JSON.stringify(ref.content));
            ref2 = ref.content;
            for (j = 0, len = ref2.length; j < len; j++) {
              property = ref2[j];
              if (property.meta == null) {
                property.meta = {};
              }
              property.meta.ref = member.content.href;
              if ((base = property.meta).links == null) {
                base.links = [];
              }
              property.meta.links.push({
                relation: 'origin',
                href: 'http://refract.link/included-member/'
              });
            }
            properties.splice.apply(properties, [i, 1].concat(ref.content));
            continue;
          }
          if (member.content.key) {
            member.content.key = dereference(member.content.key, dataStructures);
          }
          if (member.content.value) {
            member.content.value = dereference(member.content.value, dataStructures);
          }
        }
        root.content = uniqueMembers(properties);
        return root;
      default:
        ref = dataStructures[root.element];
        if (ref) {
          return dereference(inherit(ref, root), dataStructures);
        } else {
          return root;
        }
    }
  };

}).call(this);



/*****************
 ** WEBPACK FOOTER
 ** ./~/eidolon/lib/dereference.js
 ** module id = 1137
 ** module chunks = 0
 **/